<div>
  {{ config.value }}
</div>
